import {
    ASSET_CREATE,
    ASSET_CREATE_PAGE_LOADED,
    ASSET_CREATE_PAGE_UNLOADED,
    ASSET_UPDATE,
    ASSET_UPDATE_PAGE_UNLOADED,
    ASSET_LIST_PAGE_LOADED,
    ASSET_LIST_PAGE_UNLOADED,
    ASSET_DETAIL_PAGE_LOADED,
    ASSET_DETAIL_PAGE_UNLOADED,
    TOKEN_LIST_PAGE_LOADED,
    TOKEN_LIST_PAGE_UNLOADED,
    TOKEN_DETAIL_PAGE_LOADED,
    TOKEN_DETAIL_PAGE_UNLOADED
} from '../constants/actionTypes';

export default (state = {}, action) => {
    switch (action.type) {
        case ASSET_CREATE:
        case ASSET_UPDATE:
            return {
                ...state,
                errors: action.error ? action.payload.error : null,
            };
        case ASSET_DETAIL_PAGE_LOADED:
            return {
                ...state,
                asset: action.error ? null : action.payload.asset,
            }
        case ASSET_LIST_PAGE_LOADED:
            return {
                ...state,
                assets: action.error ? null : action.payload.assets,
            }
        case TOKEN_LIST_PAGE_LOADED:
            return {
                ...state,
                tokens: action.error ? null : action.payload.tokens,
            }
        case TOKEN_DETAIL_PAGE_LOADED:
            return {
                ...state,
                token: action.error ? null : action.payload.token,
            }
        case ASSET_CREATE_PAGE_UNLOADED:
        case ASSET_UPDATE_PAGE_UNLOADED:
        case ASSET_LIST_PAGE_UNLOADED:
        case ASSET_DETAIL_PAGE_UNLOADED:
        case TOKEN_LIST_PAGE_UNLOADED:
        case TOKEN_DETAIL_PAGE_UNLOADED:
            return {};
        default:
            return state;
    }
};
